import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, CompanyDamageReport, FeatureType, Grid, ListItem, ModalSize, User } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { CompanyDamageReportComponent } from './company-damage-report.component'

@Component({
    selector: 'app-company-damage-reports',
    templateUrl: './company-damage-reports.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class CompanyDamageReportsComponent extends BaseComponent {
    public grid: Grid<CompanyDamageReport>

    reportedByMap!: DataMap

    activeUserList: ListItem<string>[] = []
    allUsers: User[] = []

    get currentUserId(): string {
        return this.services.authentication.userId()
    }

    constructor() {
        super()
        this.grid = new Grid<CompanyDamageReport>(this.services)
            .setupModalEditing(
                this.services.data.companyDamageReports,
                'Company Damage Report',
                CompanyDamageReportComponent,
                () => CompanyDamageReport.createNew(),
                this,
                ModalSize.extraLarge,
            )
            .wrapColumnHeaders()
            .filterBy(item => [
                item.damageKind,
                item.location,
                item.reportedByName,
                item.assetNumber,
                item.dotClassification,
                item.foremanSuperintendent,
            ])
        this.grid.canEdit = this.canEdit
        this.grid.canAdd = this.canEdit
        this.grid.canDelete = this.canEdit
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.users.queryAllByAction('GetForLookup'),
                    this.services.data.companyDamageReports.queryAll(),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()

                        this.allUsers = result[0] as User[]
                        this.reportedByMap = new DataMap(this.allUsers, 'id', 'displayName')
                        this.activeUserList = this.allUsers.filter(u => u.active).map(u => new ListItem(u.id, u.displayName))

                        const items = result[1] as CompanyDamageReport[]
                        this.assignReportedByNames(items, this.allUsers)
                        this.grid.items = items
                    },
                }),
        )
    }

    private assignReportedByNames(items: CompanyDamageReport[], allUsers: User[]) {
        const nameById = new Map(allUsers.map(u => [u.id, u.displayName]))
        for (const item of items) {
            if (!item.reportedByName && item.reportedByUserId) {
                item.reportedByName = nameById.get(item.reportedByUserId) ?? ''
            }
        }
    }

    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.SafetyChecklistEdit])
    }
}
